module.exports = __webpack_public_path__ + "img/layout-2.d7d82fce.jpg";